<template>
  <canvas
    :id="pickIndex + 'shaftRow'"
    width="5"
    height="5"
    @click="handleCanvasClick"
  ></canvas>
</template>

<script>
import { FILE_MODIFIED } from "../../../store/modules/uptData/constants";
export default {
  name: "ShaftRow",
  props: {
    shaftData: { type: Array, required: true },
    squareDimension: { type: Number, required: true },
    pickIndex: { type: Number, required: true },
    color: { type: String, default: "blue" }
  },

  mounted: function() {
    this.draw();
  },

  computed: {
    editShaft() {
      return this.$store.state.uptData.editShaft;
    }
  },

  watch: {
    squareDimension() {
      this.draw();
    },
    shaftData() {
      this.draw();
    }
  },

  methods: {
    draw() {
      var canvas = document.getElementById(this.pickIndex + "shaftRow");
      if (canvas.getContext) {
        const ctx = canvas.getContext("2d");
        const width = (this.squareDimension + 2) * this.shaftData.length;
        ctx.canvas.width = width;
        const height = this.squareDimension;
        ctx.canvas.height = height;
        ctx.fillStyle = this.color;
        ctx.strokeStyle = this.color;
        ctx.lineWidth = 1;
        this.shaftData.forEach((jacquardValue, i) => {
          switch (jacquardValue) {
            case 3:
              ctx.fillRect(
                i * this.squareDimension + i * 2,
                0,
                this.squareDimension,
                this.squareDimension
              );
              break;
            case 0:
              ctx.strokeRect(
                i * this.squareDimension + i * 2 + 0.5,
                0.5,
                this.squareDimension - 1,
                this.squareDimension - 1
              );
              break;
            case 1:
              ctx.strokeRect(
                i * this.squareDimension + i * 2 + 0.5,
                0.5,
                this.squareDimension - 1,
                this.squareDimension - 1
              );
              ctx.beginPath();
              ctx.moveTo(
                i * this.squareDimension +
                  i * 2 +
                  0.5 +
                  this.squareDimension -
                  1,
                this.squareDimension - 1
              );
              ctx.lineTo(
                i * this.squareDimension +
                  i * 2 +
                  0.5 +
                  this.squareDimension -
                  1,
                0.5
              );
              ctx.lineTo(
                i * this.squareDimension + i * 2 + 0.5,
                this.squareDimension - 1
              );
              ctx.fill();
              break;
            case 2:
              ctx.strokeRect(
                i * this.squareDimension + i * 2 + 0.5,
                0.5,
                this.squareDimension - 1,
                this.squareDimension - 1
              );
              ctx.beginPath();
              ctx.moveTo(i * this.squareDimension + i * 2 + 0.5, 0.5);
              ctx.lineTo(
                i * this.squareDimension +
                  i * 2 +
                  0.5 +
                  this.squareDimension -
                  1,
                0.5
              );
              ctx.lineTo(
                i * this.squareDimension + i * 2 + 0.5,
                this.squareDimension - 1
              );
              ctx.fill();
          }
        });
      }
    },
    async handleCanvasClick(event) {
      if (this.editShaft) {
        const clickedIndex = Math.floor(
          event.offsetX / (this.squareDimension + 2)
        );
        let value;
        if (this.$store.state.settings.useHmt) {
          value = (this.shaftData[clickedIndex] + 1) % 4;
        } else {
          value = this.shaftData[clickedIndex] === 0 ? 3 : 0;
        }
        this.shaftData[clickedIndex] = value;
        this.$store.dispatch(FILE_MODIFIED);
        this.draw();
      }
    }
  }
};
</script>

<style scoped>
canvas {
  vertical-align: bottom;
}
</style>
